import { UserList, UserEdit, UserDiscountCreate, UserDiscountEdit } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

const name = 'user';

const icon = 'fa-users';

export default {
    pages: {
        UserList,
        UserEdit,
        UserDiscountCreate,
        UserDiscountEdit,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name,
    icon,
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/User/index.ts